import {createEvent, createStore} from 'effector';

const $section = createStore({
    section: 'DASHBOARD',
    scroll: true
});

const on = {
    set: createEvent(),
};

$section.on(on.set, (store, result) => {
    return result;
});

const section = {
    $section,
    on,
};

export default section;
